import React, { useState, useContext, useEffect } from 'react';
import { useDebounce } from 'react-use';
import { getPenalties } from '../../core/services/penalty';
import { AppContext } from '../../core/Contexts/AppContext';
import { Navigate } from 'react-router-dom';

export const PenaltyPage = (props) => {
  const { data } = props; // Extract data object

  const [inputValue, setInputValue] = useState('');

  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const { setTitle, setHeaderType, setImage } = useContext(AppContext);

  useEffect(() => {
    setTitle('სამართალდარღვევის ოქმები და დადგენილებები');
    setImage('../../images/hero-images/pattern-bg-optimized.jpg');
    setHeaderType(1);
  }, [setTitle, setImage, setHeaderType]);

  // Handle the search when the button is clicked
  const handleSearch = async () => {
    if (!inputValue) return;

    setLoading(true);
    try {
      const penalties = await getPenalties(inputValue);
      setResponse(penalties);
    } catch (err) {
      console.error('Error fetching penalties:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section>
      <div className='container'>
        <div className='paragraph'>
          თუ დადგენილების ან/და ადმინისტრაციული სამართალდამრღვევის ოქმის
          ჩაბარება ადრესატისთვის ვერ ხერხდება, აღნიშნული დადგენილება ან/და
          ადმინისტრაციული სამართალდამრღვევის ოქმი საჯაროდ გამოქვეყნდება სსიპ -
          ბაზარზე ზედამხედველობის სააგენტოს ოფიციალურ ვებგვერდზე (
          <a href='https://www.msa.gov.ge'>www.msa.gov.ge</a>).
        </div>
        <div className='penalty_box'>
          <div className='penalty_box_input'>
            <label>
              შეიყვანეთ სამართალდამრღვევის დასახელება ან საიდენტიფიკაციო კოდი
            </label>
            <input
              className='penalty_input'
              type='text'
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              placeholder='სამართალდამრღვევის დასახელება / საიდენტიფიკაციო კოდი'
            />
          </div>
          <button type='button' onClick={handleSearch}>
            ძებნა
          </button>
        </div>
        {!loading &&
          response &&
          response.length > 0 &&
          response.map(
            (penalty) =>
              penalty.id && ( // Ensure penalty.id exists
                <div className='penalty_extended' key={penalty.id}>
                  <div className='penalty_extended_item'>
                    <span>კომპანიის სახელი: </span>{' '}
                    {penalty.company_name || 'N/A'}
                  </div>
                  <div className='penalty_extended_item'>
                    <span>საიდენტიფიკაციო ნომერი / პირადი ნომერი:</span>
                    {penalty.company_id_number || 'N/A'}
                  </div>
                  <div className='penalty_extended_item'>
                    <span>გამოქვეყნების თარიღი: </span>{' '}
                    {penalty.created_at.split(' ')[0] || 'N/A'}
                  </div>
                  <div className='penalty_extended_item'>
                    <a
                      href={`/penalty/detail/${penalty.id}`}
                      className='semi-bold font__size--14 text__14-1024 btn btn__outlined--blue color__blue no__opacity rounded-2 shadow'
                    >
                      იხილეთ სრულად
                    </a>
                  </div>
                </div>
              )
          )}
        {!loading && response && response.length === 0 && (
          <div className='penalty_extended'>მონაცემი ვერ მოინახა</div>
        )}
        {loading && <div className='penalty_extended'>მიმდინარეობს ძიება</div>}
      </div>
    </section>
  );
};
